import Component from './Component.vue'

export type { UrlInputItem } from './types'
export default Component
